import { z } from "zod";
/**
 * Attributs / stats agrégées (radar Armory, R6/R7).
 * Clés = enum `Stat` (Etheria_Items ItemFactory.statsOf). Map libre pour couvrir les extensions.
 */
export const STAT_KEYS = [
    "DAMAGE",
    "DEFENSE",
    "HEALTH",
    "CRIT",
    "CRIT_DAMAGE",
    "SPEED",
    "ATTACK_SPEED",
    "MANA",
    "MANA_REGEN",
    "HEALTH_REGEN",
    "INTELLIGENCE",
    "STRENGTH",
    "AGILITY",
    "LUCK",
    "LIFESTEAL",
    "ARMOR",
    "ARMOR_TOUGHNESS",
    "KNOCKBACK_RESISTANCE",
];
export const StatKeySchema = z.enum(STAT_KEYS);
/** Bloc de stats : map ouverte clé→valeur (permet des stats custom au-delà de l'enum). */
export const StatsSchema = z.record(z.string(), z.number());
/** Libellés FR des stats connues. */
export const STAT_LABEL_FR = {
    DAMAGE: "Dégâts",
    DEFENSE: "Défense",
    HEALTH: "Points de vie",
    CRIT: "Critique",
    CRIT_DAMAGE: "Dégâts critiques",
    SPEED: "Vitesse",
    ATTACK_SPEED: "Vitesse d'attaque",
    MANA: "Mana",
    MANA_REGEN: "Régén. mana",
    HEALTH_REGEN: "Régén. vie",
    INTELLIGENCE: "Intelligence",
    STRENGTH: "Force",
    AGILITY: "Agilité",
    LUCK: "Chance",
    LIFESTEAL: "Vol de vie",
    ARMOR: "Armure",
    ARMOR_TOUGHNESS: "Robustesse d'armure",
    KNOCKBACK_RESISTANCE: "Résistance au recul",
};
//# sourceMappingURL=stats.js.map